export const CONFIRMATION_DIALOG_MESSAGES = {
  CANCEL: {
    TITLE: 'Cancel Changes',
    DESCRIPTION: 'Are you sure you want to cancel?'
  },
  CANCEL_HEHM_DEVICE: {
    TITLE: 'Cancel Subscription',
    DESCRIPTION: 'Are you sure you want to cancel the subscription for this device? You will no longer receive data for this system.'
  },
  RESTORE: {
    TITLE: 'Restore Device',
    DESCRIPTION: 'Are you sure you want to restore this device?'
  },
  DELETE: {
    TITLE: (componentName: string) => `Delete ${componentName}`,
    DESCRIPTION: (componentName: string) =>
      `Are you sure you want to delete this ${componentName.toLowerCase()}? This action cannot be undone.`
  },
  UNPIN: {
    TITLE: (customerName: string) => `Unpin ${customerName}`,
    DESCRIPTION: (customerName: string) =>
      `Are you sure you want to unpin ${customerName}?`
  },
  ERROR_MESSAGE: {
    DELETE_FAILED: 'Delete Failed',
    SAVE_FAILED: 'Save Failed'
  },
  BUTTON_TEXT: {
    CONFIRM: 'Confirm',
    DISCARD: 'Discard',
    DELETE: 'Delete',
    OK: 'OK',
    CANCEL: 'Cancel',
    YES: 'Yes',
    NO: 'No'
  },
  SUCCESS_MESSAGE: {
    TITLE: 'Success',
    DESCRIPTION: 'Changes saved successfully.'
  },
  FAILURE_MESSAGE: {
    TITLE: 'Failure',
    DESCRIPTION: 'Changes failed to save.'
  },
  SAVE_CONFIGURATION: {
    TITLE: 'Save Configuration',
    DESCRIPTION: 'Are you sure you want to save these changes?'
  }
}
